import { render, staticRenderFns } from "./CanvasTest.vue?vue&type=template&id=aa5be0b4&"
import script from "./CanvasTest.vue?vue&type=script&lang=js&"
export * from "./CanvasTest.vue?vue&type=script&lang=js&"
import style0 from "./CanvasTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports